import createInput from '../../../shared/Form/createInput';

export default {
  name: createInput('Brand name', { type: 'text' }, { required: true }),
};
